import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { arenaService } from '@/services/arena';

export function useArenaTicketList() {
    const { confirmAndRemove } = useCrudActions();
    const { list, total, fetchList } = useBaseListView({ request: arenaService.ticket.list });

    const actions = {
        remove: confirmAndRemove({
            request: arenaService.ticket.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions };
}
